import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/gpu/x2048.png'
import _imports_1 from '@/assets/ram/x2048.png'
import _imports_2 from '@/assets/hdd/x2048.png'
import _imports_3 from '@/assets/cpu/x2048.png'
import _imports_4 from '@/assets/blue-blur.svg'


const _withScopeId = n => (_pushScopeId("data-v-1c6db1f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tp-target-tile" }
const _hoisted_2 = { class: "tp-target-tile__inner" }
const _hoisted_3 = { class: "tp-target-tile__inner-value" }
const _hoisted_4 = {
  key: 0,
  src: _imports_0,
  class: "tp-target-tile__image"
}
const _hoisted_5 = {
  key: 1,
  src: _imports_1,
  class: "tp-target-tile__image"
}
const _hoisted_6 = {
  key: 2,
  src: _imports_2,
  class: "tp-target-tile__image"
}
const _hoisted_7 = {
  key: 3,
  src: _imports_3,
  class: "tp-target-tile__image"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  class: "tp-target-tile__backgroud-blur"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tp_done = _resolveComponent("tp-done")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.value || 0), 1),
      (_ctx.isImageVisible(_ctx.types.gpu))
        ? (_openBlock(), _createElementBlock("img", _hoisted_4))
        : _createCommentVNode("", true),
      (_ctx.isImageVisible(_ctx.types.ram))
        ? (_openBlock(), _createElementBlock("img", _hoisted_5))
        : _createCommentVNode("", true),
      (_ctx.isImageVisible(_ctx.types.hdd))
        ? (_openBlock(), _createElementBlock("img", _hoisted_6))
        : _createCommentVNode("", true),
      (_ctx.isImageVisible(_ctx.types.cpu))
        ? (_openBlock(), _createElementBlock("img", _hoisted_7))
        : _createCommentVNode("", true),
      _hoisted_8,
      (_ctx.done === true)
        ? (_openBlock(), _createBlock(_component_tp_done, {
            key: 4,
            class: "tp-target-tile__done"
          }))
        : _createCommentVNode("", true)
    ])
  ]))
}